import first from "lodash/first";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useContentHelper } from "~/components/content/hooks";
import type { contentAuthorLinkContent$key } from "~/queries/__generated__/contentAuthorLinkContent.graphql";

import { AuthorEntityLink } from "./styles";

type Props = {
  reference: contentAuthorLinkContent$key;
};

export const ContentAuthorLink: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const content = useFragment(
    graphql`
      fragment contentAuthorLinkContent on Content {
        authors {
          name
          ...entityLink
        }
        ...hooksContentHelperContent
      }
    `,
    reference_,
  );
  const { isEditorialOpinionType, isScmpOpinionType } = useContentHelper(content);
  if (!(isScmpOpinionType || isEditorialOpinionType)) return null;

  const mainAuthor = first(content.authors);
  if (!mainAuthor) return null;

  return <AuthorEntityLink reference={mainAuthor}>{mainAuthor.name}</AuthorEntityLink>;
};
